itsoftApp.createModule("noprep", function() {
    var noPreparing = function(){
        $("body").removeClass("is-preparing");
    };

    var sliderParent = $(".js-slider-1");

    if (!sliderParent.length) {
        noPreparing();

        return false;

    }
});